import React from "react";
import ErrorLayout from "../components/layouts/ErrorPageLayout";
import { Box, Typography } from "@mui/material";
import { ReactComponent as PageNotFound } from "../assets/svgs/404.svg";

const Login = () => {
  return (
    <ErrorLayout>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
      >
        <PageNotFound />
        <Typography
          fontSize="30px"
          lineHeight="60px"
          textAlign="center"
          fontWeight="700"
          sx={{ mt: "25px" }}
        >
          Page not found!
        </Typography>
        <Typography
          fontSize="16px"
          lineHeight="22px"
          textAlign="center"
          sx={{ color: "#8E8E8E" }}
        >
          The requested URL was not found on our server.
        </Typography>
      </Box>
    </ErrorLayout>
  );
};

export default Login;
